module.exports = __webpack_public_path__ + "img/1.ed2087d3.png";